module.exports = __webpack_public_path__ + "static/media/4374.926d0ed6.jpg";